import lodash from "lodash";
import Vue from "vue";
/** PagesEnum 自动生成请勿修改  */
/** @InjectPages **/
export const PagesEnum = {
    /** pages/index  */
    Index: { name: 'index' },
    /** pages/player/index  */
    Player: { name: 'player' }
};
/** @InjectPages **/
lodash.set(Vue, '$Pages', PagesEnum);
Object.defineProperty(Vue.prototype, "$Pages", {
    get: lodash.constant(PagesEnum),
});
